import React, {Component} from 'react';

class PoliticaCheckButton extends Component {
    constructor(props) {
        super(props);

        this.onOkPolitica = this.onOkPolitica.bind(this);
    }

    onOkPolitica(value) {
        const {onOkPolitica} = this.props;
        const {target: {checked}} = value;

        if (this.props.onOkPolitica) {
            onOkPolitica(checked)
        }
    }

    render() {
        return (
            <label
                className="custom-control custom-checkbox custom-solid-checkbox custom-solid-checkbox-info label-checkbox-politica">
                <input
                    id="checkbox-politica"
                    className="form-check-input"
                    type="checkbox"
                    onChange={this.onOkPolitica}
                />
                {/*<span className="custom-control-indicator"></span>*/}
                <span className="custom-accept-policy">
                    He leído y acepto el
                    <a href='https://www.adopta-un-animal.es/articulos/aviso-legal/'
                       target='_blank'> aviso legal </a>
                     y la
                    <a href='https://www.adopta-un-animal.es/articulos/politica-privacidad/PoliticaCheckButton.jsx'
                       target='_blank'> política de privacidad.</a>
                </span>
            </label>
        )
    }

}


export default PoliticaCheckButton